import { useContext, useEffect, useState } from 'react';
import { M28ProductOverview } from 'ui/components/3-organisms/M28ProductOverview/M28ProductOverview';
import { DictionaryContext } from 'application/adapters/context/Dictionary';
import { PageContext } from 'application/adapters/context/PageContext';
import { useFormContext } from 'application/adapters/context/FormContext';
import { useRouter } from 'next/router';
import { useContactLinkQuery } from 'application/hooks/useContactLinkQuery';

export const M28ProductOverviewFeature: React.FC<Umbraco.M28ProductOverview> = ({ content }) => {
	const dictionary = useContext(DictionaryContext);
	const pageContext = useContext(PageContext);
	const formContext = useFormContext();
	const router = useRouter();
	const contactLink = pageContext.contactLink;
	const culture = router.locale;
	const { properties } = content;
	const carouselImages = content?.properties?.carouselImages ?? [];

	const { queryParam } = useContactLinkQuery(contactLink);

	// Use useState + useEffect to prevent hydration mismatch.
	// Server renders with empty URL, client updates after hydration.
	const [contactFormLink, setContactFormLink] = useState('');

	useEffect(() => {
		const currentUrl = window.location.pathname;
		setContactFormLink(`${currentUrl}?${queryParam}`);
	}, [queryParam]);

	const sliderDictionary = {
		buttonNext: dictionary.getValue('M28ProductOverview.ButtonNext', null, 'next image'),
		buttonPrev: dictionary.getValue('M28ProductOverview.ButtonPrev', null, 'previous image'),
		buttonTitle: dictionary.getValue('M28ProductOverview.ButtonTitle', null, 'Request a quote'),
		showMore: dictionary.getValue('M28ProductOverview.ShowMore', null, 'Show more'),
		showLess: dictionary.getValue('M28ProductOverview.ShowLess', null, 'Show less'),
	};

	// Map Array of carousel images to Array of slider items
	// TODO: need to be optimized to use Slider and its sliderItems
	const mappedSlides = carouselImages?.map(({ properties, url, focalPoint }) => {
		const slideItem = {
			heading: '',
			text: '',
			image: {
				url: url,
				focalPoint: focalPoint,
				properties: properties,
			},
		};

		return slideItem;
	});

	const handleContactFormClick = (e: React.MouseEvent) => {
		e.preventDefault();

		// Update URL without navigation (instant)
		const newUrl = `${window.location.pathname}?${queryParam}${window.location.hash}`;
		window.history.pushState(null, '', newUrl);

		formContext.open();
	};

	if (!properties) {
		return null;
	}
	return (
		<M28ProductOverview
			{...properties}
			carouselImages={mappedSlides}
			dictionary={sliderDictionary}
			contactFormLink={contactFormLink}
			onContactClick={handleContactFormClick}
			contactFormLoading={formContext.isLoading}
		/>
	);
};
